"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoyTheme = require("buoy-theme");

var _buoyTheme2 = _interopRequireDefault(_buoyTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div.withConfig({
  displayName: "CheckIcon__Container",
  componentId: "sc-18grq27-0"
})(_templateObject);

var CheckIcon = function CheckIcon(_ref) {
  var color = _ref.color;
  return _react2.default.createElement(
    Container,
    null,
    _react2.default.createElement(
      "svg",
      {
        width: "13px",
        height: "10px",
        viewBox: "0 0 13 10",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink" },
      _react2.default.createElement(
        "g",
        {
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        },
        _react2.default.createElement(
          "g",
          {
            transform: "translate(-480.000000, -1633.000000)",
            stroke: _buoyTheme2.default.colors[color],
            strokeWidth: "1.5"
          },
          _react2.default.createElement(
            "g",
            { transform: "translate(481.000000, 1634.000000)" },
            _react2.default.createElement("polyline", { points: "11.1428571 0 3.48214286 7.66071429 0 4.17857143" })
          )
        )
      )
    )
  );
};

CheckIcon.defaultProps = {
  color: "primary"
};

exports.default = CheckIcon;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-icons/dist/icons/CheckIcon.js
// module id = 416
// module chunks = 168707334958949